(() => {
 if(window.momsukaliCartGroupsReady)return;
 window.momsukaliCartGroupsReady=true;
 let busy=false;
 const groupOf=item=>item.properties?._ms_group||item.properties?.['Box reference'];
 document.addEventListener('click',async event=>{
  const button=event.target.closest('[data-ms-remove-group]');if(!button)return;
  event.preventDefault();if(busy)return;
  const status=document.querySelector('[data-ms-cart-status]');
  const checkouts=[...document.querySelectorAll('[name="checkout"]')].map(node=>[node,node.disabled]);
  busy=true;button.disabled=true;checkouts.forEach(([node])=>node.disabled=true);
  if(status)status.textContent='Removing your box and its toppings…';
  try{
   const root=window.Shopify?.routes?.root||'/';
   const response=await fetch(root+'cart.js',{headers:{Accept:'application/json'}});
   if(!response.ok)throw Error('Your bag could not be checked. Please try again.');
   const cart=await response.json();
   const parent=cart.items.find(item=>item.key===button.dataset.msLineKey);
   if(!parent||!parent.properties?.Flavours||groupOf(parent)!==button.dataset.msRemoveGroup)throw Error('Your bag has changed. Please refresh the page and try again.');
   const group=groupOf(parent),updates={};
   for(const item of cart.items)if(groupOf(item)===group&&(item.key===parent.key||item.properties?.['Paid topping']))updates[item.key]=0;
   const remaining=cart.items.filter(item=>!(item.key in updates));
   if(remaining.length&&remaining.every(item=>item.properties?.['Pot choice']))for(const item of remaining)updates[item.key]=0;
   const result=await fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({updates})});
   if(!result.ok)throw Error('The box could not be removed. Please refresh your bag and try again.');
   const updated=await result.json();
   if(updated.items.some(item=>item.key in updates))throw Error('Please refresh your bag to check the removal.');
   location.reload();
  }catch(error){
   if(status)status.textContent=error.message||'Please try again.';
   busy=false;button.disabled=false;checkouts.forEach(([node,disabled])=>node.disabled=disabled);
  }
 });
})();
